module.exports = new __parcel__URL__("MyFlixArchDiagram.b29548ed.png").toString();